import Axios from 'axios';
const client = Axios.create({ withCredentials: true });
client.interceptors.request.use(config => {
    const tokenMeta = document.head.querySelector('meta[name="csrfToken"]');
    if (tokenMeta) {
        config.headers["Csrf-Token"] = tokenMeta.getAttribute('content');
        // console.debug(`ajax header => ${JSON.stringify(config.headers, null, "  ")}`);
    }
    return config;
});
export function getUser() {
    return client.get('/api/user');
}
export function saveUserDetail(userDetail) {
    return client.post(`/api/user/save/detail`, userDetail);
}
